export const FETCH_ORGANISATIONS = "[RECEPTIONIST] FETCH_ORGANISATIONS";
export const FETCH_ORGANISATIONS_SUCCESS =
  "[RECEPTIONIST] FETCH_ORGANISATIONS_SUCCESS";
export const FETCH_ORGANISATIONS_ERROR =
  "[RECEPTIONIST] FETCH_ORGANISATIONS_ERROR";

export const CREATE_ORGANISATION = "[RECEPTIONIST] CREATE_ORGANISATION";
export const CREATE_ORGANISATION_SUCCESS =
  "[RECEPTIONIST] CREATE_ORGANISATION_SUCCESS";
export const CREATE_ORGANISATION_ERROR =
  "[RECEPTIONIST] CREATE_ORGANISATION_ERROR";

export const UPDATE_ORGANISATION = "[RECEPTIONIST] UPDATE_ORGANISATION";
export const UPDATE_ORGANISATION_SUCCESS =
  "[RECEPTIONIST] UPDATE_ORGANISATION_SUCCESS";
export const UPDATE_ORGANISATION_ERROR =
  "[RECEPTIONIST] UPDATE_ORGANISATION_ERROR";

export const SEARCH_ORGANISATION = "[RECEPTIONIST] SEARCH_ORGANISATION";
export const SEARCH_ORGANISATION_SUCCESS =
  "[RECEPTIONIST] SEARCH_ORGANISATION_SUCCESS";
export const SEARCH_ORGANISATION_ERROR =
  "[RECEPTIONIST] SEARCH_ORGANISATION_ERROR";

export const FETCH_ORGANISATIONS_SERVICES = "FETCH_ORGANISATIONS_SERVICES";
export const FETCH_ORGANISATIONS_SERVICES_SUCCESS =
  "FETCH_ORGANISATIONS_SERVICES_SUCCESS";
export const FETCH_ORGANISATIONS_SERVICES_ERROR =
  "FETCH_ORGANISATIONS_SERVICES_ERROR";

export const fetchOrganisations = (payload) => {
  return {
    type: FETCH_ORGANISATIONS,
    payload: payload,
  };
};

export const createOrganisation = (payload) => {
  return {
    type: CREATE_ORGANISATION,
    payload: payload,
  };
};

export const updateOrganisation = (payload) => {
  return {
    type: UPDATE_ORGANISATION,
    payload: payload,
  };
};

export const searchOrganisation = (payload) => {
  return {
    type: SEARCH_ORGANISATION,
    payload: payload,
  };
};

export const fetchOrganisationsServices = (payload) => {
  return {
    type: FETCH_ORGANISATIONS_SERVICES,
    payload: payload,
  };
};
